// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"499":"2e6fafc7","859":"b94ade0b"}[chunkId] + ".css";
};